import * as fromDatatype from "../datatype-library/index";

export interface bl_alg_cc_queue_rule_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    queue_guid: fromDatatype.GuidDataFieldInterface;
    rule_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_alg_cc_queue_rule_link_RowClass implements bl_alg_cc_queue_rule_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    queue_guid: fromDatatype.GuidDataFieldInterface;
    rule_guid: fromDatatype.GuidDataFieldInterface;
}